"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER = exports.OWNED_BY_ANOTHER = exports.VEHICLE = exports.PROPERTY = exports.PERSONAL = exports.FINANCIAL = exports.BUSINESS = exports.AGRICULTURE = void 0;
var AGRICULTURE = 'agriculture';
exports.AGRICULTURE = AGRICULTURE;
var BUSINESS = 'business';
exports.BUSINESS = BUSINESS;
var FINANCIAL = 'financial';
exports.FINANCIAL = FINANCIAL;
var PERSONAL = 'personal';
exports.PERSONAL = PERSONAL;
var PROPERTY = 'property';
exports.PROPERTY = PROPERTY;
var VEHICLE = 'vehicle';
exports.VEHICLE = VEHICLE;
var OWNED_BY_ANOTHER = 'owned_by_another';
exports.OWNED_BY_ANOTHER = OWNED_BY_ANOTHER;
var OTHER = 'other';
exports.OTHER = OTHER;